import React, { useState, useEffect, useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Bar } from 'react-chartjs-2';

import loadingSvg from '../../assets/loading.svg';

import {
  getChannelViews,
  getPlaylistSortedByViews,
} from '../../services/youtube-api';

export default function MostPopularEpisodes() {
  const [loading, setLoading] = useState(true);
  const [totalChannelViews, setTotalChannelViews] = useState(0);
  const [episodeViews, setEpisodeViews] = useState([]);
  const channels = ['UCSHZKyawb77ixDdsGog4iWA', 'UCJIfeSCssxSC_Dhc5s7woww'];

  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        edges {
          node {
            id
            guest
          }
        }
      }
    }
  `);

  useEffect(() => {
    const fetchData = async () => {
      const sorted = await getPlaylistSortedByViews(
        'PLrAXtmErZgOdP_8GztsuKi9nrraNbKKp4'
      );
      const channelViews =
        parseInt(await getChannelViews(channels[0])) +
        parseInt(await getChannelViews(channels[1]));
      setEpisodeViews(sorted);
      setTotalChannelViews(channelViews);
      setLoading(false);
    };

    fetchData();
  }, []);

  const totalEpisodeViews = episodeViews
    .map((ep) => ep.views)
    .reduce((a, b) => parseInt(a) + parseInt(b), 0);
  const top20 = episodeViews.slice(0, 20);
  const viewsTop20 = top20
    .map((ep) => ep.views)
    .reduce((a, b) => parseInt(a) + parseInt(b), 0);

  const chartData = {
    labels: top20.map(
      (ep) =>
        `${ep.id} - ${data.allEpisodesJson.edges
          .find((edge) => edge.node.id === ep.id.toString())
          .node.guest.replace(' | ', ', ')}`
    ),
    datasets: [
      {
        label: 'Views',
        data: top20.map((ep) => ep.views),
        backgroundColor: ['#3b85f2'],
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      y: {
        ticks: {
          color: '#d1d5db',
        },
        grid: {
          display: false,
        },
      },
      x: {
        ticks: {
          color: '#d1d5db',
          callback: function (value) {
            return `${(value / 1000000).toFixed(0)} M`;
          },
        },
        grid: {
          color: '#273045',
        },
        title: {
          display: true,
          text: 'Views (millions)',
          color: '#d1d5db',
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div>
      <h3 className="text-2xl">Most popular episodes</h3>
      {loading ? (
        <div className="w-10 h-10 mt-7">
          <img src={loadingSvg} />
        </div>
      ) : !totalChannelViews || !episodeViews ? (
        <p>N/A</p>
      ) : (
        <>
          <p>
            The <span className="text-hl">20</span> most viewed LFP episodes on
            YouTube have{' '}
            <span className="text-hl">
              {(viewsTop20 / 1000000).toFixed(1)} million
            </span>{' '}
            views and account for{' '}
            <span className="text-hl">
              {((viewsTop20 / totalEpisodeViews) * 100).toFixed(1)}%
            </span>{' '}
            of the total views on all episodes or{' '}
            <span className="text-hl">
              {((viewsTop20 / totalChannelViews) * 100).toFixed(1)}%
            </span>{' '}
            of those on Lex Fridman and Lex Clips YouTube channels combined.
          </p>
          <div className="h-xll mt-5 border border-gray-700 hover:border-gray-600 shadow-2xl rounded-md p-5 max-w-7xl">
            <Bar data={chartData} options={chartOptions} />
          </div>
        </>
      )}
    </div>
  );
}
